export default __webpack_public_path__ + "static/media/mtn-money.4e9a0766.png";